import React from 'react';
import {
  TextField,
  InputLabel,
  createTheme,
  ThemeProvider,
  InputAdornment,
} from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { IoIosArrowDown } from 'react-icons/io';

const CustomInput = ({ small, type, startIcon, ...props }) => {
  return (
    <>
      {type === 'phone_number' ? (
        <MuiTelInput
          defaultCountry="NG"
          {...props}
          sx={{ mt: 1 }}
          fullWidth
          InputProps={{
            style: {
              fontFamily: 'lato',
              fontSize: '13px',
              borderRadius: '10px',
              offset: ' 1px solid #737373',
              fontWeight: 500,
              height: small && '45px',
            },
            inputMode: type === 'number' && 'numeric',
          }}
        />
      ) : (
        <TextField
          {...props}
          type={type}
          margin="dense"
          SelectProps={{
            IconComponent: IoIosArrowDown,
            displayEmpty: true,
          }}
          InputProps={{
            style: {
              fontFamily: 'lato',
              fontSize: '13px',
              borderRadius: '10px',
              offset: ' 1px solid #737373',
              fontWeight: 500,
              height: small && '45px',
            },
            inputMode: type === 'number' && 'numeric',
            startAdornment: (
              <InputAdornment position="start">{startIcon}</InputAdornment>
            ),
          }}
        />
      )}
    </>
  );
};

export default CustomInput;
